/* src/puzzle-editor.svelte generated by Svelte v4.1.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	empty,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_custom_element_data,
	space,
	text
} from "svelte/internal";

import "svelte/internal/disclose-version";
import { onDestroy, getContext } from 'svelte';

import {
	handleInputValue,
	SavingPuzzleState,
	getTodayDate,
	defaultContextId,
	createdPuzzle$,
	setCreatedPuzzleImageURL,
	setCreatedPuzzleDate,
	saveEditedPuzzle,
	savingPuzzle$,
	getSavingPuzzle
} from "core";

function create_if_block(ctx) {
	let cookies_panel;
	let cookies_p0;
	let t1;
	let cookies_p1;
	let t3;
	let cookies_p2;
	let t5;
	let input;
	let t6;
	let button;
	let t7;
	let button_disabled_value;
	let t8;
	let t9;
	let mounted;
	let dispose;
	let if_block0 = /*savingPuzzleState*/ ctx[1] === SavingPuzzleState.Pending && create_if_block_2(ctx);
	let if_block1 = /*savingPuzzleState*/ ctx[1] === SavingPuzzleState.UnknownError && create_if_block_1(ctx);

	return {
		c() {
			cookies_panel = element("cookies-panel");
			cookies_p0 = element("cookies-p");
			cookies_p0.textContent = "Chaque jour, une nouvelle partie d'une image est dévoilée.\n\t\t\tLes participants doivent deviner quelle est cette image.";
			t1 = space();
			cookies_p1 = element("cookies-p");
			cookies_p1.textContent = "Fournissez un lien direct vers l'image que vous souhaitez utiliser pour le puzzle.\n\t\t\tCliquez sur créer, et partagez ensuite le lien de l'énigme avec les participants.";
			t3 = space();
			cookies_p2 = element("cookies-p");
			cookies_p2.innerHTML = `<cookies-a href="https://fr.wikihow.com/obtenir-l%27URL-des-images">Comment obtenir le lien d&#39;une image sur internet ?</cookies-a>`;
			t5 = space();
			input = element("input");
			t6 = space();
			button = element("button");
			t7 = text("Creer le puzzle");
			t8 = space();
			if (if_block0) if_block0.c();
			t9 = space();
			if (if_block1) if_block1.c();
			attr(input, "aria-label", "image-url-input");
			attr(input, "type", "text");
			attr(input, "placeholder", "https://.../mon-image.jpg");
			button.disabled = button_disabled_value = !/*puzzle*/ ctx[2] && /*savingPuzzleState*/ ctx[1] !== SavingPuzzleState.Pending;
			attr(button, "aria-label", "puzzle-save-button");
			set_custom_element_data(cookies_panel, "panel-title", "Editer le puzzle");
			set_custom_element_data(cookies_panel, "data-testid", /*dataTestid*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, cookies_panel, anchor);
			append(cookies_panel, cookies_p0);
			append(cookies_panel, t1);
			append(cookies_panel, cookies_p1);
			append(cookies_panel, t3);
			append(cookies_panel, cookies_p2);
			append(cookies_panel, t5);
			append(cookies_panel, input);
			append(cookies_panel, t6);
			append(cookies_panel, button);
			append(button, t7);
			append(cookies_panel, t8);
			if (if_block0) if_block0.m(cookies_panel, null);
			append(cookies_panel, t9);
			if (if_block1) if_block1.m(cookies_panel, null);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_handler*/ ctx[6]),
					listen(button, "click", /*click_handler*/ ctx[7])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*puzzle, savingPuzzleState*/ 6 && button_disabled_value !== (button_disabled_value = !/*puzzle*/ ctx[2] && /*savingPuzzleState*/ ctx[1] !== SavingPuzzleState.Pending)) {
				button.disabled = button_disabled_value;
			}

			if (/*savingPuzzleState*/ ctx[1] === SavingPuzzleState.Pending) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					if_block0.m(cookies_panel, t9);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*savingPuzzleState*/ ctx[1] === SavingPuzzleState.UnknownError) {
				if (if_block1) {
					
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					if_block1.m(cookies_panel, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*dataTestid*/ 1) {
				set_custom_element_data(cookies_panel, "data-testid", /*dataTestid*/ ctx[0]);
			}
		},
		d(detaching) {
			if (detaching) {
				detach(cookies_panel);
			}

			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

// (52:2) {#if savingPuzzleState === SavingPuzzleState.Pending }
function create_if_block_2(ctx) {
	let cookies_p;

	return {
		c() {
			cookies_p = element("cookies-p");
			cookies_p.textContent = "Lien en cours de vérification...";
		},
		m(target, anchor) {
			insert(target, cookies_p, anchor);
		},
		d(detaching) {
			if (detaching) {
				detach(cookies_p);
			}
		}
	};
}

// (58:2) {#if savingPuzzleState === SavingPuzzleState.UnknownError }
function create_if_block_1(ctx) {
	let cookies_p0;
	let t1;
	let cookies_p1;
	let t3;
	let cookies_p2;
	let t5;
	let cookies_p3;

	return {
		c() {
			cookies_p0 = element("cookies-p");
			cookies_p0.textContent = "Le lien de l'image que vous avez fourni ne semble pas fonctionner.";
			t1 = space();
			cookies_p1 = element("cookies-p");
			cookies_p1.textContent = "Il est possible que le site web qui héberge cette image ne n'autorise\n\t\t\t\tpas qu'elle soit affichée depuis un autre site web.";
			t3 = space();
			cookies_p2 = element("cookies-p");
			cookies_p2.textContent = "Pour résoudre ce problème, vous pouvez essayer d'utiliser un proxy CORS.\n\t\t\t\tUn proxy CORS agit comme un intermédiaire, permettant ainsi de contourner\n\t\t\t\tles restrictions. Vous pouvez facilement trouver un service en ligne gratuit\n\t\t\t\tpour générer un lien proxy pour votre lien.";
			t5 = space();
			cookies_p3 = element("cookies-p");
			cookies_p3.textContent = "Il est également possible que le lien lui-même soit invalide. Veuillez vérifier\n\t\t\t\tque le lien est correct et qu'il s'agit bien d'une image valide.";
		},
		m(target, anchor) {
			insert(target, cookies_p0, anchor);
			insert(target, t1, anchor);
			insert(target, cookies_p1, anchor);
			insert(target, t3, anchor);
			insert(target, cookies_p2, anchor);
			insert(target, t5, anchor);
			insert(target, cookies_p3, anchor);
		},
		d(detaching) {
			if (detaching) {
				detach(cookies_p0);
				detach(t1);
				detach(cookies_p1);
				detach(t3);
				detach(cookies_p2);
				detach(t5);
				detach(cookies_p3);
			}
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let if_block = !/*savedPuzzle*/ ctx[3] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (!/*savedPuzzle*/ ctx[3]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) {
				detach(if_block_anchor);
			}

			if (if_block) if_block.d(detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { dataTestid = undefined } = $$props;
	let { contextId = defaultContextId } = $$props;
	const context = getContext(contextId);
	const todayDate = getTodayDate(context.dateStorage);
	let savingPuzzleState = getSavingPuzzle();
	const subSav = savingPuzzle$.subscribe(value => $$invalidate(1, savingPuzzleState = value));
	let puzzle = null;
	let savedPuzzle = null;
	const sub = createdPuzzle$.subscribe(value => $$invalidate(2, puzzle = value));
	context.puzzleStorage.read().then(value => $$invalidate(3, savedPuzzle = value)).catch(console.error);
	let sub3 = context.puzzleStorage.watch().subscribe(value => $$invalidate(3, savedPuzzle = value));
	setCreatedPuzzleDate(todayDate);
	onDestroy(() => sub.unsubscribe());
	onDestroy(() => subSav.unsubscribe());
	onDestroy(() => sub3.unsubscribe());
	const input_handler = e => handleInputValue(setCreatedPuzzleImageURL)(e);
	const click_handler = () => saveEditedPuzzle(context, puzzle);

	$$self.$$set = $$props => {
		if ('dataTestid' in $$props) $$invalidate(0, dataTestid = $$props.dataTestid);
		if ('contextId' in $$props) $$invalidate(5, contextId = $$props.contextId);
	};

	return [
		dataTestid,
		savingPuzzleState,
		puzzle,
		savedPuzzle,
		context,
		contextId,
		input_handler,
		click_handler
	];
}

class Puzzle_editor extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { dataTestid: 0, contextId: 5 });
	}
}

export default Puzzle_editor;